<template>
	<div class="thirdCard">
		<img style="width: 1280px; height: 358px; position: absolute; left: -40px; top: -40px;" src="../../../assets/icon_dean_home_bg_card_2.png" alt="" />
		<div style="position: absolute;  left: 0px; right: 0px; top: 0px; bottom: 0px; display: flex; flex-direction: column;">
			<div style="display: flex; height: 39px; justify-content: space-between;">
				<div style="display: flex; align-items: center; align-self: flex-end;">
					<div style="width: 5px; height: 20px; background: #4A7CE8; border-radius: 0px 3px 3px 0px"></div>
					<div style="font-size: 18px; font-family: PingFangSC, PingFang SC; font-weight: 600; color: #1F2635; line-height: 24px; margin-left: 15px;">状态优秀的长者</div>
					<div style="display: flex; align-items: center; margin-left: 5px;" :style="{opacity: !data ? 0 : 1}">
						<img style="width: 7px; height: 8px; z-index: 1;" src="../../../assets/icon_common_special_arrow_0.png" alt="" />
						<div style="margin-left: -2px; background: #E0F5F0; border-radius: 4px; border: 1px solid #B6EBDF; padding: 2px 5px; font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 600; color: #35C0A0; line-height: 20px;">{{ dataLength + '位' }}</div>
					</div>
				</div>
				<div v-if="data && dataLength > 5" style="display: flex; align-items: center; align-self: flex-end; margin-bottom: 7px;">
					<img style="width: 73px; height: 14px; margin-right: 10px;" src="../../../assets/icon_dean_home_bg_card_icon_1.png" alt="" />
					<div style="display: flex; align-items: center; margin-right: 20px;" @click="seeAll()">
						<div style="font-size: 16px; font-family: PingFangSC, PingFang SC; font-weight: 600; color: #4A7CE8; line-height: 22px; margin-right: 2px; cursor: pointer;">查看全部</div>
						<img style="width: 16px; height: 16px;" src="../../../assets/icon_dean_home_bg_card_icon_8.png" alt="" />
					</div>
				</div>
			</div>
			<div v-if="!data" style="width: 1160px; height: 199px; background: #ECF0F3; box-shadow: inset 8px 8px 20px 0px #D1D9E6, inset -8px -8px 20px 0px #FFFFFF; border-radius: 16px; margin-top: 20px; margin-left: 20px; display: flex; justify-content: center; align-items: center; flex-direction: column;">
				<img v-if="emptyString != '院长端未关联任何设备'" style="width: 107px; height: 107px; z-index: 1;" :src="require(emptyString == '所有设备离线，请尽快检查设备情况，恢复守护状态' ? '../../../assets/icon_dean_home_card_empty_icon_2.png' : emptyString == '睡眠设备赶紧用起来才能看到更多内容哦' ? '../../../assets/icon_dean_home_card_empty_icon_1.png' : '../../../assets/icon_dean_home_card_empty_icon_3.png')" alt="" />
				<div v-if="emptyString != '院长端未关联任何设备'" style="font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #A4ABB6; line-height: 20px; margin-top: 15px;">{{ emptyString || ' ' }}</div>
			</div>
			<div v-if="data" style="height: 234px; display: flex; flex-direction: column;">
				<div style="height: 164pxpx; position: relative;">
					<div style="height: 100%; position: absolute; z-index: 0; width: 100%;">
						<el-carousel :interval="5000000" arrow="never" height="234px" :loop="false" indicator-position='none' ref="homeDeanThirdCardRef" @change="carouselChange" >
							<el-carousel-item v-for="(item,index) in data || []" :key="index" >
								<div style="width: 100%; height: 100%; display: flex;padding-left: 20px;">
									<div class="miniCardHover" @click="itemClick(subItem)" v-for="(subItem,subIndex) in item || []" style="width: 220px; height: 199px; box-shadow: 5px 5px 8px 0px #D1D9E6, -5px -5px 8px 0px #FFFFFF; border-radius: 16px; display: flex; flex-direction: column;" :style="{marginRight: subIndex == 4 ? '0px' : '15px'}">
										<div style="flex: 1; display: flex; position: relative; justify-content: center;">
											<div style="flex: 1; margin-bottom: 10px; margin-left: 5px; margin-right: 5px; margin-top: 5px; background: #F3F9F9; border-radius: 12px; border: 1px solid #B6EBDF; display: flex; flex-direction: column;">
												<div class="richTextDiv" style="flex: 1; display: flex; flex-direction: column; padding-left: 10px; padding-right: 10px;">
													<div 
													class="description"
													v-if="miniIndex <= 1" 
													v-for="(miniItem, miniIndex) in subItem.stateExcellentTextList || []" 
													style="background: #E0F5F0; border-radius: 8px; height: 40px; margin-top: 10px; display: flex; align-items: center; position: relative;"
													>
														<div v-html="$options.filters.reMate(miniItem)" style="width: 170px; margin-left: 10px;"></div>
														<div class="showDescription" style="position: absolute; background: #FFFFFF; z-index: 1000; top: 30px; padding: 10px; border-radius: 8px; display: none;" :style="{left: subIndex == 4 ? '-50%' : '50%'}">
															<div v-html="$options.filters.reMate(miniItem)"></div>
														</div>
													</div>
												</div>
												<div style="display: flex; height: 34px; justify-content: space-between; margin-bottom: 10px; padding-left: 10px; padding-right: 10px;">
													<div style="width: 38px; height: 24px; background: rgba(94, 103, 121, 0.1); border-radius: 19px 19px 19px 2px; font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #5E6779; line-height: 20px; display: flex; align-items: center; padding-left: 8px;" :style="{opacity: subItem && subItem.stateExcellentTextList && subItem.stateExcellentTextList.length > 2 ? 1 : 0}">…</div>
													<div style="width: 58px; height: 30px; background: rgba(74, 124, 232, 0.15); border-radius: 20px; font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 600; color: #4A7CE8; line-height: 20px; display: flex; justify-content: center; align-items: center; align-self: flex-end;">查看</div>
												</div>
											</div>
											<img style="position: absolute; width: 16px; height: 12px; bottom: 0px;" src="../../../assets/icon_common_special_arrow_3.png" alt="" />
										</div>
										<div class="bedName" style="display: flex; margin-bottom: 10px; align-items: center; justify-content: center; padding-left: 10px; padding-right: 10px; position: relative;">
											<div class="miniCardHoverImg" style="width: 20px; height: 20px; margin-right: 5px;" alt=""></div>
											<div class="miniCardHoverText" style="font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; line-height: 20px; white-space: nowrap; text-overflow: ellipsis; overflow: hidden; max-width: 175px;">{{ subItem.bedName || '' }}</div>
											<div class="showDescription" style="position: absolute; background: #FFFFFF; z-index: 1000; top: -40px; padding: 10px; border-radius: 8px; display: none; z-index: 10000;" :style="{left: subIndex == 4 ? '-50%' : '50%'}">
												<div style="font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; line-height: 20px; white-space: nowrap; color: rgba(94, 103, 121, 1);">{{ subItem.bedName || '' }}</div>
											</div>
										</div>
									</div>
								</div>
							</el-carousel-item>
						</el-carousel>
					</div>
					<img 
					style="position: absolute; width: 96px; height: 96px; left: -5px; top: 75px; z-index: 1; cursor: pointer;"
					:src="require('../../../assets/' + (leftBtnState == 1 ? 'icon_dean_home_bg_card_icon_12' : 'icon_dean_home_bg_card_icon_11') + '.png')" 
					onselectstart="return false" 
					alt=""
					@click="clickArrow(1)"
					v-if="currentPage != 1"
					@mouseover="leftBtnHover"
					@mouseout="leftBtnRemoveHover"
					/>
					<img 
					style="position: absolute; width: 96px; height: 96px; right: -5px; top: 75px; z-index: 1; cursor: pointer;"
					:src="require('../../../assets/' + (rightBtnState == 1 ? 'icon_dean_home_bg_card_icon_14' : 'icon_dean_home_bg_card_icon_13') + '.png')" 
					onselectstart="return false" 
					alt=""
					@click="clickArrow(2)"
					v-if="currentPage != data.length"
					@mouseover="rightBtnHover"
					@mouseout="rightBtnRemoveHover"
					/>
				</div>
			</div>
		</div>
		
		<ThirdCardAllAlert ref="thirdCardAllAlert" @itemClick="itemClick"></ThirdCardAllAlert>
		<PortraitAlert ref="thirdCardAllAlertPortraitAlert"></PortraitAlert>

	</div>
</template>
  
<script>
import ThirdCardAllAlert from './thirdCardAllAlert.vue'; 
import PortraitAlert from './portraitAlert.vue';        //弹窗_数字画像
import portFn from '../../../utils/PortraitFunction.js';
import CustomRichText from '../../../utils/CustomRichText.js';

export default {
	components: {
		ThirdCardAllAlert,
		PortraitAlert
	},
	filters: {
		reMate(val){
			return CustomRichText.reMateNew(portFn.function_reg_str_to_arr(val))
		},
	},
	props: {
		data: {
			type: Array,
			default: null
		},
		dataLength: {
			type: Number,
			default: 0
		},
		emptyString: {
			type: String,
			default: null
		}
	},
	watch: {
	},
	data() {
		return {
			leftBtnState: 0,
			rightBtnState: 0,
			currentPage: 1,
			hoverText: null
		};
	},
	created() { },
	mounted() {

	},
	methods: {
		carouselChange(){
			let activeIndex = this.$refs.homeDeanThirdCardRef.activeIndex
      		this.currentPage = Number(activeIndex + 1)
		},
		clickArrow(type) {
			if(type == 1){
				this.$refs.homeDeanThirdCardRef.prev()
			}else {
				this.$refs.homeDeanThirdCardRef.next()
			}
		},
		leftBtnHover() {
			this.leftBtnState = 1;
			this.rightBtnState = 0;
		},
		leftBtnRemoveHover() {
			this.leftBtnState = 0;
			this.rightBtnState = 0;
		},
		rightBtnHover() {
			this.leftBtnState = 0;
			this.rightBtnState = 1;
		},
		rightBtnRemoveHover() {
			this.leftBtnState = 0;
			this.rightBtnState = 0;
		},
		seeAll() {
			this.$refs.thirdCardAllAlert.openAlert()
		},
		itemClick(item) {
			this.$refs.thirdCardAllAlertPortraitAlert.openAlert(item)
		},
	},
};
</script>
<style lang="scss" scoped>
.thirdCard {
	height: 278px;
	position: relative;
	display: flex;
	margin-top: 30px;
}
.miniCardHover {
	margin-top: 20px;
	background: #ECF0F3;
	cursor: pointer;
	.miniCardHoverText {
		color: #5E6779;
	}
	.miniCardHoverImg {
		background: url('../../../assets/icon_dean_home_bg_card_icon_6.png') no-repeat no-repeat;
		background-size: contain;
	}
}
.miniCardHover:hover {
	background: #DFE8FC;
	.miniCardHoverText {
		color: #4A7CE8;
	}
	.miniCardHoverImg {
		background: url('../../../assets/icon_dean_home_bg_card_icon_7.png') no-repeat no-repeat;
		background-size: contain;
	}
}

.richTextDiv ::v-deep {
	.richContentStyle {
		display: block;
		white-space: nowrap;
		height: 20px;
		text-overflow: ellipsis;
		overflow: hidden;
	}
	.richTextStyleNormal {
		font-size: 14px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		color: #5E6779;
		line-height: 20px;
		white-space: nowrap;
		display: inline;
	}
	.richTextStyleGreen {
		font-size: 14px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		color: rgba(53, 192, 160, 1);
		line-height: 20px;
		white-space: nowrap;
		display: inline;
	}
}

.description:hover {
	.showDescription {
		display: block !important;
	}
}

.bedName:hover {
	.showDescription {
		display: block !important;
	}
}

</style>
  